module.exports = __webpack_public_path__ + "img/Tom Doherty.81c964bf.png";